import { ApiFindOptions, useApiFind } from '../../../../../lib/HttpService';
import { PATH } from './const';
import { PATH as ROSTER_PATH } from '../const';
import { StubbornRouter } from '../../../../../application/business/StubbornRouter';

export const useRosterRouterContextFind = (options: ApiFindOptions = {}) => useApiFind<StubbornRouter>(`${ROSTER_PATH}${PATH}`, options)